import React from 'react';
import classNames from 'classnames';
import styles from './person.module.scss';
import { PersonInterface } from './person.interface';

const Person: React.FunctionComponent<PersonInterface> = ({
  componentRef,
  className,
  name,
  position,
  avatarUrl,
  isCustomColor = false,
}) => {
  return (
    <div
      ref={componentRef}
      className={classNames(styles.component, className, {
        [styles.isCustomColor]: isCustomColor,
      })}
    >
      {avatarUrl && (
        <img
          className={styles.avatar}
          src={avatarUrl}
          alt={name}
        />
      )}

      <h3 className={styles.name}>
        {name}
      </h3>

      <p className={styles.position}>
        {position.join(', ')}
      </p>
    </div>
  );
};

export default Person;
